/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import PropTypes from 'prop-types';
import React from 'react';
import RouterContext from './Context';

let shouldNavigate = event =>
  !event.defaultPrevented && event.button === 0 && !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);

class Link extends React.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    if (this.props.onClick) {
      this.props.onClick(e);
    }

    if (shouldNavigate(e)) {
      this.context.router.trigger(this.props.href, false, this.props.root);
      e.preventDefault();
    }
  }

  render() {
    let path = this.context.fullPrefix || '';
    let Element = this.props.element;
    let href = this.props.href;

    if (!this.props.root) {
      if (/^\//.test(href)) {
        path = path.replace(this.context.prefix, '');
      } else {
        href = '/' + href;
      }
    }

    return (
      <Element {...this.props} href={path + href} onClick={this.onClick}>
        {this.props.children}
      </Element>
    );
  }
}

Link.defaultProps = {
  element: 'a'
};

Link.propTypes = {
  children: PropTypes.node,
  element: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.func]),
  href: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  root: PropTypes.bool
};

Link.contextType = RouterContext;

export default Link;
